import type { IconName } from "@similarweb/icons";

import { extractCrmAndObjectType } from "../helpers/crmList";
import type { OpportunityListOption } from "../types";
import { OpportunityListVariant } from "../types";

export const getListIcon = (list: OpportunityListOption): IconName => {
    switch (list.variant) {
        case OpportunityListVariant.Crm: {
            const { crm } = extractCrmAndObjectType(list.id);

            return crm as IconName;
        }
        case OpportunityListVariant.Static:
            return "list-icon";
    }
};
